/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import {
	View,
	Button,
	BoxSpinnerView,
	BoxInitEmptyView,
	BoxEmptyView,
} from '@components/atoms'
import { UserList } from '@components/molecules'

import {
	useAppSelector,
	useAppDispatch,
	accessControlActions,
	ApiGetDataStatus,
	CrudType,
} from '@redux/index'
import { grey } from '@mui/material/colors'
import { UserType } from '@schemas'

interface PropsType {
	status: ApiGetDataStatus
	userList: UserType[]
}

export const AccessGroupUserList = (props: PropsType) => {
	const { status, userList } = props

	// redux dispatch
	const reduxDispatch = useAppDispatch()

	// redux state
	const crud: CrudType = useAppSelector(state => state.auth.currentAccess)

	const onEditUsers = () => {
		reduxDispatch(accessControlActions.LEFT_MODAL_TAB_INDEX(1))
		reduxDispatch(accessControlActions.SHOW_SIDE_MODAL(true))
	}

	return (
		<View css={style}>
			{status === 'init' ? (
				<BoxInitEmptyView />
			) : status === 'loading' ? (
				<BoxSpinnerView />
			) : status === 'empty' ? (
				<BoxEmptyView isGrey={true} title="그룹 멤버가 없습니다." />
			) : status === 'ok' ? (
				<View className="userListOuter">
					<View className="userListView">
						<UserList
							status={status}
							userList={userList}
							showSearch={false}
							showDepartmentName={false}
							userInfoClassName="userInfo"
						/>
					</View>
					{crud.includes('U') && (
						<View className="memberEditView">
							<Button
								className="memberEditButton"
								variant="contained"
								onClick={onEditUsers}
							>
								멤버 수정
							</Button>
						</View>
					)}
				</View>
			) : null}
		</View>
	)
}

const style = css({
	position: 'relative',
	overflow: 'hidden',
	width: '100%',
	height: '100%',
	padding: '0',
	background: grey[50],
	border: `1px solid ${grey[200]}`,
	borderRadius: '5px',

	'.userListOuter': {
		height: '100%',
		padding: '0.5rem 0',

		'.userListView': {
			height: 'calc(100% - 3.2rem)',
			padding: '0 0.5rem',
			overflowY: 'auto',

			'.userInfo': {
				position: 'relative',
				background: '#FFF',
				border: '1px solid',
				borderColor: grey[300],

				'.userInfoLeftAccessory': {
					position: 'absolute',
					right: '0.5rem',
					top: '0.7rem',
				},
			},
		},

		'.memberEditView': {
			position: 'absolute',
			width: '100%',
			bottom: 0,
			left: 0,
			padding: '0.5rem',

			'.memberEditButton': {
				width: '100%',
			},
		},
	},
})
